import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ProviderInvoiceCategoryForm from "@components/forms/ProviderInvoiceCategoryForm";

const ProviderInvoiceCategoryAddEdit = () => {
  const params = useParams()
  const { id: providerInvoiceCategoryId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!providerInvoiceCategoryId ? 'Agregar' : 'Editar'} Categoria de Compras`}
      backUrl="/user/provider-invoices/categories"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "providerInvoiceCategoryForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ProviderInvoiceCategoryForm
        formId="providerInvoiceCategoryForm"
        id={providerInvoiceCategoryId}
        saveRedirectUrl="/user/provider-invoices/categories"
      ></ProviderInvoiceCategoryForm>

    </PageContainer>
  );
}

export default ProviderInvoiceCategoryAddEdit;
